export enum EQuoteDeductionStatus {
  Added = "Added",
  Applied = "Applied",
  NotActive = "NotActive",
  Expired = "Expired",
  Removed = "Removed"
}
